import React, { Component } from 'react';
import './App.css';
import Header from './components/Header/index';
import Middler from './components/Middler/index';
import Footer from './components/Footer/index';
import vconsole from 'vconsole';
if (window.location.href.indexOf("debug") > -1) {
  new vconsole();
}

export default class App extends Component {

  render() {
    return (
      <div>
        <Header />
        <Middler />
        <Footer />
      </div>
    )
  }
}
